import { Paper, styled } from '@mui/material';

import theme from '@/styles/theme';

export const Card = styled(Paper)(() => ({
  display: 'flex',
  flexDirection: 'column',
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: `${theme.shape.borderRadiusLarge}px`,
  padding: theme.spacing(2),
  marginBottom: theme.spacing(2),
  breakInside: 'avoid-column',
}));
